import React from "react";
import Context from "../../../../../../context";
import {
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../../components";
import { useTranslation } from "react-i18next";

const CompanyInformation = () => {
  const { showModal, setShowModal, selectedSuperAgent } = React.useContext(
    Context.SuperAgentCityScreen
  );

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"35vw"}
        maxWidth={"50vw"}
        open={showModal === "SHOW_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedSuperAgent?.avatar}
            name={
              selectedSuperAgent?.firstName
                ? selectedSuperAgent?.firstName
                : selectedSuperAgent?.name
            }
            lastName={
              selectedSuperAgent?.lastName ? selectedSuperAgent?.lastName : ""
            }
            phoneNumber={
              selectedSuperAgent?.phoneNumber
                ? selectedSuperAgent?.phoneNumber
                : selectedSuperAgent?.telephone
            }
            isBlock={null}
          />
          <hr />

          <CustomView.Row className="form-column-row">
            {selectedSuperAgent?.superAgentSchoolInformation?.nationalCode && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("nationalCode")} :</label>
                <p>
                  {
                    selectedSuperAgent?.superAgentSchoolInformation
                      ?.nationalCode
                  }
                </p>
              </CustomView.Column>
            )}
            {selectedSuperAgent?.superAgentSchoolInformation?.city
              ?.ProvinceName && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("province")} :</label>
                <p>
                  {
                    selectedSuperAgent?.superAgentSchoolInformation?.city
                      ?.ProvinceName
                  }
                </p>
              </CustomView.Column>
            )}
            {selectedSuperAgent?.superAgentSchoolInformation?.city
              ?.TownName && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("city")} :</label>
                <p>
                  {
                    selectedSuperAgent?.superAgentSchoolInformation?.city
                      ?.TownName
                  }
                </p>
              </CustomView.Column>
            )}
            {selectedSuperAgent?.superAgentSchoolInformation?.address && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("address")} :</label>
                <p>
                  {selectedSuperAgent?.superAgentSchoolInformation?.address}
                </p>
              </CustomView.Column>
            )}
            {selectedSuperAgent?.financial?.kartNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("cardNumber")} :</label>
                <p>{selectedSuperAgent?.financial?.kartNumber}</p>
              </CustomView.Column>
            )}
            {selectedSuperAgent?.financial?.shabaNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("shabaNumber")} :</label>
                <p>{selectedSuperAgent?.financial?.shabaNumber}</p>
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default CompanyInformation;
